import { render } from "./ImageElement.vue?vue&type=template&id=3873d245"
import script from "./ImageElement.vue?vue&type=script&lang=js"
export * from "./ImageElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__